import { notification } from 'antd'
import { Steps } from 'antd-mobile'
import { Form } from 'formsy-semantic-ui-react'
import Cookie from 'js-cookie'
import qs from 'query-string'
import * as R from 'ramda'
import React, { Component } from 'react'
import { Button, Confirm, Label } from 'semantic-ui-react'
import {
  getAddonByRace,
  getRaceBySlug,
  getRaceDetailByRace
} from '../../api/async/index'
import { shouldShowConfirmPayment } from '../../api/async/participants/index'
import { getAccountDetail, patchAccountDetail } from '../../api/sync/index'
import { getGroupByRace, postRegisterRace } from '../../api/sync/races/index'
import AccountAndMailingForm from '../../components/AccountAndMailingForm/index'
import AccountDetailPresentation from '../../components/AccountDetail/index'
import MailingAddressPresentation from '../../components/MailingAddress/index'
import { SelectAddon } from '../../components/ShirtAddon'
import { shouldShowAccountDetail } from './utils'
import { endRegisterRace } from '../../utils'

class RegisterRace extends Component {
  state = {
    activeIndex: 0,
    racesDetail: [],
    confirmOpen: false,
    addons: [],
    showAccountDetail: false,
    canSubmit: false,
    country: 'Thailand',
    special: false,
    disableSubmit: false,
    selected_shirt: [],
    groups: []
  }

  componentDidMount = async () => {
    const raceSlug = this.props.match.params.slug
    const raceRes = await getRaceBySlug(raceSlug)
    this.setState({ race: raceRes.data })

    const query = qs.parse(this.props.history.location.search)
    const res = await getRaceDetailByRace(this.state.race.id)
    this.setState({ racesDetail: res.data })

    const groups = await getGroupByRace(this.state.race.id)
    this.setState({ groups: groups.data })

    if (query.duplicate !== 'true') {
      shouldShowConfirmPayment(this.state.race.id).then(result => {
        if (result) {
          this.props.history.push('/me')
          notification.warning({
            message:
              'คุณได้สมัครงานวิ่งนี้ไว้แล้ว กรุณาตรวจสอบสถานะการสมัครของคุณ'
          })
        }
      })
    }

    if (endRegisterRace(this.state.race)) {
      this.props.history.push('/')
      notification.warning({
        message: `งานวิ่ง ${this.state.race.title} ปิดรับสมัครแล้ว`
      })
    }
    getAccountDetail().then(res => {
      this.setState({ ...R.filter(R.identity, res.data) })
      const { username, name, phone_number, gender, birth_day } = res.data
      const listAccountDetail = [
        username,
        name,
        phone_number,
        gender,
        birth_day
      ]
      this.setState({
        showAccountDetail: shouldShowAccountDetail(listAccountDetail)
      })
      this.updateBirthDayField()
    })
    getAddonByRace(this.state.race.id).then(res => {
      this.setState({ addons: res.data })
    })

    // this.setSpecial()
  }

  setSpecial = () => {
    const search = this.props.location.search
    const params = qs.parse(search)
    const special = Cookie.get('run-24hrs-special') || params.special || false
    this.setState({ special })
  }

  updateBirthDayField = () => {
    this.setState({ day: this.state.birth_day.split('-')[2] })
    this.setState({ month: this.state.birth_day.split('-')[1] })
    this.setState({ year: this.state.birth_day.split('-')[0] })
  }

  disableButton = () => {
    this.setState({ canSubmit: false })
  }

  enableButton = () => {
    this.setState({ canSubmit: true })
  }

  handleClickAccordian = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    const newIndex = activeIndex === index ? -1 : index
    this.setState({ activeIndex: newIndex })
  }

  onClickNext = () => {
    this.setState({ confirmOpen: false })
    this.setState({ activeIndex: this.state.activeIndex + 1 })
  }

  onClickBack = () => {
    this.setState({ activeIndex: this.state.activeIndex - 1 })
  }

  openConfirmOpen = () => {
    this.setState({ confirmOpen: true })
  }

  updateBirthDay = () => {
    this.setState({
      birth_day: `${this.state.year}-${this.state.month}-${this.state.day}`
    })
  }

  handleSubmit = () => {
    this.setState(
      {
        birth_day: `${this.state.year}-${this.state.month}-${this.state.day}`
      },
      () => {
        patchAccountDetail(this.state)
        if (!this.state.disableSubmit) {
          this.setState({ disableSubmit: true })
          postRegisterRace(this.state).then(res => {
            if (res.status <= 201) {
              this.setState({ disableSubmit: false })
              this.props.history.push(`/participants/payment/${res.data.id}`)
            }
          })
        }
      }
    )
  }

  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value })
  }

  setNumberOfAddon = (name, value) => {
    const selectedAddons = this.state[name] || []
    this.setState({ [name]: selectedAddons.splice(0, value) })
  }

  handleNumberOfAddonChange = (e, { name, value }) => {
    const addonType = name.split('numberOf')[1]
    if (this.state[`numberOf${addonType}`] > value) {
      this.setNumberOfAddon(`selected_${addonType}`, value)
    }
    if (this.state.addons.filter(each => each.type == addonType).length == 1) {
      this.setState({
        [`selected_${addonType}`]: Array(value).fill(
          this.state.addons.filter(each => each.type == addonType)[0].id
        )
      })
    }

    if (value.toString().startsWith('no_')) {
      this.setState({ [`numberOf${addonType}`]: 0 })
      this.setState({ [`selected_${addonType}`]: [] })
      return
    }
    this.setState({ [name]: value })
  }

  handleRadioChange = (e, type) => {
    const selected = this.state[`selected_${type}`] || []
    const addonId = e.target.value
    const selectAddonIndex = e.target.selectAddonIndex

    selected[selectAddonIndex] = addonId
    this.setState({ [e.target.name]: selected })
  }
  handleAddressSelect = address => {
    this.setState({ province: address.p })
    this.setState({ sub_district: address.d })
    this.setState({ district: address.a })
    this.setState({ postal_code: address.z })
  }

  render() {
    const {
      activeIndex,
      racesDetail,
      showAccountDetail,
      race_detail,
      selected_shirt,
      addons,
      groups
    } = this.state
    const selectedGroup = R.find(R.propEq('id', this.state.group))(
      this.state.groups
    )
    const distanceOption = [...racesDetail]
      .filter(each =>
        each.distance.name.includes(R.propOr('', ['name'], selectedGroup))
      )
      .map((detail, _) => ({
        key: detail.id,
        text: `${detail.distance.name} - ${detail.race.title}`,
        value: detail.id
      }))

    const groupOption = [...groups].map(group => ({
      key: group.id,
      text: `${group.name} ${group.close_register ? '(เต็มแล้ว)' : ''}`,
      value: group.id,
      disabled: group.close_register
    }))
    const errorLabel = <Label color="red" pointing />
    return (
      <React.Fragment>
        <Steps direction="horizontal" current={activeIndex} size="small">
          <Steps.Step className="mobile-step" />
          <Steps.Step className="mobile-step" />
          {showAccountDetail && <Steps.Step className="mobile-step" />}
        </Steps>
        <div style={{ display: activeIndex === 0 ? 'block' : 'none' }}>
          <Form
            id="first-step"
            style={{ marginBottom: '10px' }}
            onValidSubmit={this.onClickNext}
            onValid={this.enableButton}
            onInvalid={this.disableButton}
          >
            {groups.length ? (
              <React.Fragment>
                <h3>เลือกกลุ่ม</h3>
                <Form.Group widths="equal">
                  <Form.Select
                    required
                    name="group"
                    value={this.state.group}
                    options={groupOption}
                    placeholder="โปรดเลือกกลุ่ม"
                    onChange={this.handleChange}
                  />
                </Form.Group>
              </React.Fragment>
            ) : null}
            <h3>เลือกระยะทางวิ่ง / เดิน</h3>
            <Form.Group widths="equal">
              <Form.Select
                required
                name="race_detail"
                value={this.state.race_detail}
                options={distanceOption}
                placeholder="โปรดเลือกระยะวิ่ง"
                onChange={this.handleChange}
              />
            </Form.Group>
            {R.pathOr(
              false,
              ['race', 'open_engrave'],
              this.state.racesDetail[0]
            ) && (
              <React.Fragment>
                <h3>สลักชื่อ: (ไม่เกิน 12 ตัวอักษร)</h3>
                <Form.Group>
                  <Form.Input
                    validations="maxLength:12"
                    name="engrave"
                    className="mb10"
                    style={{ width: '350px', marginBottom: '10px' }}
                    value={this.state.engrave}
                    validationErrors={{
                      maxLength: 'โปรดกรอกไม่เกิน 12 ตัวอักษร'
                    }}
                    placeholder="สลักชื่อ: (ไม่เกิน 12 ตัวอักษร)"
                    onChange={this.handleChange}
                    errorLabel={errorLabel}
                  />
                </Form.Group>
              </React.Fragment>
            )}
            {[
              ...Object.keys(R.groupBy(R.prop('type'), addons))
                .filter(each => parseInt(each) && each !== '1')
                .reverse(),
              ...Object.keys(R.groupBy(R.prop('type'), addons)).filter(
                each => !parseInt(each)
              ),
              ...Object.keys(R.groupBy(R.prop('type'), addons)).filter(
                each => each === '1'
              )
            ].map(each => (
              <SelectAddon
                handleEngraveChange={this.handleChange}
                engrave={this.state.engrave}
                addons={addons.filter(addon => addon.type == each)}
                handleChange={this.handleNumberOfAddonChange}
                handleRadioChange={this.handleRadioChange}
                numberOf={this.state[`numberOf${each}`]}
                type={each}
                race={R.path(['race'], this.state.racesDetail[0])}
              />
            ))}
            <div>
              <Button
                color="teal"
                type="submit"
                form="first-step"
                style={{ marginTop: '10px' }}
              >
                ต่อไป
              </Button>
            </div>
          </Form>
        </div>
        <div
          style={{
            display: activeIndex === 1 && showAccountDetail ? 'block' : 'none'
          }}
        >
          <h3>ข้อมูลผู้สมัคร</h3>
          <AccountDetailPresentation
            handleChange={this.handleChange}
            handleBirthDayChange={this.handleBirthDayChange}
            birth_day={this.state.birth_day}
            email={this.state.username}
            gender={this.state.gender}
            name={this.state.name}
            phone_number={this.state.phone_number}
            onClickBack={this.onClickBack}
            onClickNext={this.onClickNext}
          />
        </div>
        <div
          style={{
            display:
              (activeIndex === 2 && showAccountDetail) ||
              (!showAccountDetail && activeIndex === 1)
                ? 'block'
                : 'none'
          }}
        >
          <h3>ที่อยู่สำหรับจัดส่งของรางวัล</h3>
          <p>(กรุณาใส่ที่อยู่ให้ละเอียด บ้านเลขที่ ซอย ถนน)</p>
          {!showAccountDetail ? (
            <AccountAndMailingForm
              handleChange={this.handleChange}
              handleBirthDayChange={this.handleBirthDayChange}
              birth_day={this.state.birth_day}
              firstname={this.state.firstname}
              lastname={this.state.lastname}
              email={this.state.username}
              gender={this.state.gender}
              name={this.state.name}
              phone_number={this.state.phone_number}
              address_1={this.state.address_1}
              sub_district={this.state.sub_district}
              district={this.state.district}
              province={this.state.province}
              country={this.state.country}
              postal_code={this.state.postal_code}
              handleAddressSelect={this.handleAddressSelect}
              onClickBack={this.onClickBack}
              onClickNext={this.openConfirmOpen}
              hideBackButton={false}
            />
          ) : (
            <MailingAddressPresentation
              firstname={this.state.firstname}
              lastname={this.state.lastname}
              address_1={this.state.address_1}
              sub_district={this.state.sub_district}
              district={this.state.district}
              province={this.state.province}
              country={this.state.country}
              postal_code={this.state.postal_code}
              handleChange={this.handleChange}
              handleAddressSelect={this.handleAddressSelect}
              onClickBack={this.onClickBack}
              onClickNext={this.openConfirmOpen}
            />
          )}
          <Confirm
            open={this.state.confirmOpen}
            cancelButton="แก้ไข"
            confirmButton="ตกลง"
            content="กรุณาตรวจสอบข้อมูลการจัดส่งให้เรียบร้อย หลังจากชำระเงินค่าสมัครแล้วไม่สามารถเปลี่ยนที่อยู่สำหรับจัดส่งของรางวัลได้"
            onCancel={() => this.setState({ confirmOpen: false })}
            onConfirm={this.handleSubmit}
          />
        </div>
      </React.Fragment>
    )
  }
}

export default RegisterRace



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/RegisterRace/index.js